;
define("facets_empty.tpl", function(){});

